import { useEffect, useState } from "react";
import { getPayments } from "features/Payments/services/PaymentService";
import {
  PaymentSourceType,
  PaymentStatus,
} from "features/Payments/constants/payment.constants";

/**
 * Whether this invoice has any direct (POSTED) payment applied to it.
 * cancel-invoice hard-rejects once this is true, so the action should be
 * disabled proactively rather than letting the user submit and hit that wall.
 */
export function useInvoiceHasDirectPayment(
  invoiceId: number | null | undefined,
  enabled: boolean,
): { loading: boolean; hasDirectPayment: boolean } {
  const [loading, setLoading] = useState(false);
  const [hasDirectPayment, setHasDirectPayment] = useState(false);

  useEffect(() => {
    if (!enabled || !invoiceId) {
      setHasDirectPayment(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    getPayments({
      sourceType: PaymentSourceType.INVOICE,
      sourceId: invoiceId,
      status: PaymentStatus.POSTED,
      limit: 1,
    })
      .then((res) => {
        if (cancelled) return;
        setHasDirectPayment((res.data?.rows?.length ?? 0) > 0);
      })
      .catch(() => {
        if (!cancelled) setHasDirectPayment(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [invoiceId, enabled]);

  return { loading, hasDirectPayment };
}
